import { PageContainer, RuntimeDiagnosticBanner, type ComponentDiagnostic } from "@swot/base-components";
import type { PermissionContext, WorkflowAction, WorkflowCommand } from "@swot/swot-components";
import { CmtsWorkflowCommandPanel } from "@components/CmtsWorkflowCommandPanel.js";

export function CmtsWorkflowPage(props: {
  complaintId: string;
  status: string;
  actions: readonly WorkflowAction[];
  actorId: string;
  actorName?: string | undefined;
  diagnostics?: readonly ComponentDiagnostic[] | undefined;
  permissionContext?: PermissionContext | null | undefined;
  onCommand: (command: WorkflowCommand) => void | Promise<void>;
}) {
  return (
    <PageContainer title="Workflow Command Center" subtitle="Allowed-action driven workflow execution with status, SoD and dependency gates.">
      {/* <RuntimeDiagnosticBanner diagnostics={props.diagnostics ?? []} title="Workflow diagnostics" /> */}
      <section className="cmts-workflow-hero">
        <div><p className="cmts-section-eyebrow">Complaint {props.complaintId}</p><h2>Current status: {props.status}</h2><p>Actions below must come from backend/offline allowed-action service. Blocked transitions must not mutate state.</p></div>
        <span className="cmts-status-chip">{props.actions.length} allowed actions</span>
      </section>
      <section className="cmts-dashboard-grid-two">
        <article className="cmts-panel-card"><h3>Workflow timeline</h3><ol className="cmts-timeline"><li>Submitted</li><li>Assigned</li><li>Investigation</li><li>RCA/CAPA</li><li>Verification</li><li>Closure</li></ol></article>
        <article className="cmts-panel-card"><h3>Dependency gates</h3><ul className="cmts-action-list"><li>Evidence requirement</li><li>RCA approval</li><li>CAPA submission</li><li>Verification result</li><li>SoD closure restriction</li></ul></article>
      </section>
      <article className="cmts-panel-card"><h3>Allowed Actions</h3><CmtsWorkflowCommandPanel {...props} diagnostics={props.diagnostics ?? []} /></article>
    </PageContainer>
  );
}
